<div class="d-flex justify-content-center align-items-center border border-right bg-dark rounded text-white">
  @if (labels) {
    <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Display Labels" i18n-title="@@app.display_labels" (click)="onToggleLabels()">
      <i class="icon-24 se-icon-action_generate_labels font-size-24 font-weight-semibold"></i>
    </div>
  }
  @if (showPdf && !isInSldMode) {
    <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" appDisableMultipleClickWithNoneEvent i18n-title="@@app.disposition_layout" title="Disposition layout" [ngClass]="{'color-icon-gray pointer-events-none' : (allProductsWithoutCover)}" (click)="generateDispositionPdf()">
      <i class="icon-24 se-icon-action_pdf_report font-size-24 font-weight-semibold"></i>
      <app-document-types
        #DispositionLayoutDescription
        [isHidden]="true"
        [property]="'disposition_layout'"
      ></app-document-types>
      <app-document-types
        #DispositionLayoutWCoversDescription
        [isHidden]="true"
        [property]="'disposition_layout_with_covers'"
      ></app-document-types>
    </div>
  }
  @if (showEnclosurePdf) {
    <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" appDisableMultipleClickWithNoneEvent i18n-title="@@app.enclosure_layout" title="Enclosure layout" (click)="generateEnclosurePdf()">
      <i class="icon-24 se-icon-action_pdf_report font-size-24 font-weight-semibold"></i>
      <app-document-types
        #EnclosureLayoutDescription
        [isHidden]="true"
        [property]="'enclosure_layout'"
      ></app-document-types>
      <app-document-types
        #EnclosureLayoutWCoverDescription
        [isHidden]="true"
        [property]="'enclosure_layout_w_covers'"
      ></app-document-types>
    </div>
  }
  @if (covers && !isInSldMode) {
    <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Toggle Covers" i18n-title="@@app.toggle_covers"
      [ngClass]="{'color-icon-gray pointer-events-none' : (allProductsWithoutCover)}"
      (click)="onToggleCovers()">
      <i class="icon-24 font-size-24 font-weight-semibold" [ngClass]="{'se-icon-building_surface1': showCovers, 'se-icon-building_surface2': !showCovers}"></i>
    </div>
  }
  @if (masslabeling && !isInSldMode) {
    <div [ngClass]="{'pointer-events-none' : (noDevicesWithLabel)}" class="masslabeling-icon pt-0 pt-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Masslabeling" i18n-title="@@app.masslabeling" (click)="onToogleMasslabeling()">
      @if (showMasslabeling) {
        <svg xmlns="http://www.w3.org/2000/svg" width="16.002" height="16.002" viewBox="0 0 18.002 18.002">
          <g id="hide_label_icon" transform="translate(-3 -2.998)">
            <g id="hidden_label_icon">
              <path id="Rectangle_1097" fill="#fff" d="M0 0H18V18H0z" opacity="0.004" transform="translate(3 2.998)"/>
              <path id="Path_854" d="M20.534 11.513l-2.612-2.606-1.061 1.06 2.611 2.6v.135l-6.765 6.765a.09.09 0 0 1-.067.028.088.088 0 0 1-.068-.028l-2.6-2.611-1.066 1.066 2.6 2.609a1.6 1.6 0 0 0 2.258 0l6.767-6.768a1.59 1.59 0 0 0 .003-2.25z" class="cls-2 fill-white" [ngClass]="{'greyed-out-icon': (noDevicesWithLabel)}"/>
              <path id="Path_855" d="M20.53 4.53l-1.06-1.06L8.094 14.846a.1.1 0 0 1-.135 0L4.5 11.381V4.5h6.88l2.649 2.643 1.061-1.061-2.651-2.644A1.5 1.5 0 0 0 11.38 3H4.5A1.5 1.5 0 0 0 3 4.5v6.884a1.5 1.5 0 0 0 .438 1.058L6.9 15.907a1.592 1.592 0 0 0 2.252 0z" class="cls-2 fill-white" [ngClass]="{'greyed-out-icon': (noDevicesWithLabel)}"/>
              <path id="Path_856" d="M8.511 10.5a2 2 0 1 1 1.414-.584 1.993 1.993 0 0 1-1.414.584zm0-2.5a.494.494 0 0 0-.353.146A.5.5 0 1 0 8.51 8z" class="cls-2 fill-white" [ngClass]="{'greyed-out-icon': (noDevicesWithLabel)}"/>
              <path id="Rectangle_1101" d="M0 0H3.432V1.5H0z" class="cls-2 fill-white" [ngClass]="{'greyed-out-icon': (noDevicesWithLabel)}" transform="rotate(-45 25.236 5.533)"/>
            </g>
          </g>
        </svg>
      } @else {
        <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16.002" viewBox="0 0 18 18.002">
          <g id="show_label_icon" transform="translate(-31 -40)">
            <path id="Rectangle_1097" fill="#fff" d="M0 0H18V18H0z" opacity="0.004" transform="translate(31 40)"/>
            <path id="Path_849" d="M4.5 4.5h6.88l8.092 8.072a.1.1 0 0 1 0 .135l-6.765 6.765a.09.09 0 0 1-.067.028.088.088 0 0 1-.068-.028L4.5 11.381V4.5m0-1.5A1.5 1.5 0 0 0 3 4.5v6.882a1.5 1.5 0 0 0 .438 1.06l8.072 8.09a1.6 1.6 0 0 0 2.258 0l6.765-6.765a1.6 1.6 0 0 0 0-2.255l-8.1-8.075A1.5 1.5 0 0 0 11.38 3z" class="cls-2 fill-white" [ngClass]="{'greyed-out-icon': (noDevicesWithLabel)}" transform="translate(28 37.002)"/>
            <path id="Path_850" d="M8.511 10.5a2 2 0 1 1 1.414-.584 1.993 1.993 0 0 1-1.414.584zm0-2.5a.494.494 0 0 0-.353.146A.5.5 0 1 0 8.51 8z" class="cls-2 fill-white" [ngClass]="{'greyed-out-icon': (noDevicesWithLabel)}" transform="translate(28 37.002)"/>
          </g>
        </svg>
      }
    </div>
  }
  <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Zoom In" i18n-title="@@app.zoom_in"
       [ngClass]="{'color-icon-gray' : (zoomLevel | zoomInUnavailable: enclosure?.configuration?.rows : enclosure?.configuration?.fields : enclosureMinMaxRange?.maxRows : enclosureMinMaxRange?.maxFields : mainContent : tab) ||
       (zoomLevel | zoomInSwitchboardUnavailable : products : selectedEnclosure : switchboardContainerEl : zoomControlsContainerEl : tab)
       }"
    (click)="zoomInGrid()">
    <i class="icon-24 se-icon-action_zoom_plus_stroke font-size-24 font-weight-semibold"></i>
  </div>
  <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Zoom Out" i18n-title="@@app.zoom_out"
       [ngClass]="{ 'color-icon-gray' : (zoomLevel | zoomOutUnavailable: enclosure?.configuration?.rows : enclosure?.configuration?.fields : enclosureMinMaxRange?.maxRows : enclosureMinMaxRange?.maxFields : mainContent: tab) ||
       (zoomLevel | zoomOutSwitchboardUnavailable : products : selectedEnclosure : switchboardContainerEl : zoomControlsContainerEl : tab) }"
    (click)="zoomOutGrid()">
    <i class="icon-24 se-icon-action_zoom_minus_stroke font-size-24 font-weight-semibold"></i>
  </div>
  <div class="pt-0 pb-1 pl-1 pr-1 cursor-pointer hover-grey-bg" title="Fit To Window" i18n-title="@@app.fit_to_window" (click)="fitToWindow()">
    <i class="icon-24 se-icon-action_resize font-size-24 font-weight-semibold"></i>
  </div>
</div>
